'use client';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useRouter } from 'next/navigation';

export function BackButton({
  children,
  className,
}: React.PropsWithChildren<{
  className?: string;
}>) {
  const router = useRouter();

  const onPressBackButton = () => {
    if (window.history.length > 1) {
      router.back();
    } else {
      router.push('/');
    }
  };

  return (
    <button className={className} onClick={onPressBackButton}>
      <ArrowLeftIcon className="h-8 w-8 text-white" />
      {children}
    </button>
  );
}
